/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Stats_Dim_GradeInputs */

const vi_lot_stats_dim_grade = /** @type {(inputs: Lot_Stats_Dim_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại chè`)
};

/**

* @param {Lot_Stats_Dim_GradeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_stats_dim_grade = /** @type {((inputs?: Lot_Stats_Dim_GradeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Stats_Dim_GradeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_stats_dim_grade(inputs)
});